import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, Eyebrow } from "../components/motion";

const FAQS = [
  {
    q: "Come si usa il Trattamento Rapida Crescita?",
    a: "Applicalo direttamente sul cuoio capelluto nelle zone interessate, massaggia delicatamente per circa 10 minuti, lascia in posa fino a 3 ore e risciacqua con due passate di shampoo. Frequenza consigliata: 2 volte a settimana.",
  },
  {
    q: "Quanto dura un flacone?",
    a: "Il flacone da 50 ml con contagocce dura indicativamente circa 1 mese con utilizzo regolare, seguendo le modalità d'uso consigliate.",
  },
  {
    q: "Il trattamento unge i capelli?",
    a: "La consistenza è leggera e, utilizzato correttamente (senza eccedere nelle quantità), non unge. Servono poche gocce sulle zone interessate.",
  },
  {
    q: "In quanto tempo vedrò i risultati?",
    a: "La cura dei capelli è un percorso che richiede costanza: ogni cute risponde in modo diverso e non possiamo promettere tempistiche certe. Ti consigliamo di seguire la routine con regolarità, scegliendo il percorso di 1, 2 o 3 mesi più adatto a te.",
  },
  {
    q: "Quale scrub fa per me?",
    a: "Se la tua cute tende a ungersi e le radici si appesantiscono in fretta, scegli lo Scrub al Tè Matcha. Se invece il tuo cuoio capelluto è secco, sensibile o soggetto a prurito, lo Scrub alla Ciliegia è la scelta più delicata. Se hai dubbi, prova il nostro percorso guidato.",
  },
  {
    q: "I prodotti contengono siliconi o parabeni?",
    a: "No. Le formule sono senza siliconi e senza parabeni, con attivi di origine naturale. I prodotti sono artigianali e non testati su animali.",
  },
  {
    q: "Quali metodi di pagamento accettate?",
    a: "Accettiamo pagamenti sicuri con carta tramite Stripe. Non serve creare un account: puoi acquistare direttamente come ospite.",
  },
  {
    q: "Come funziona lo sconto del 10% sul primo ordine?",
    a: "Semplice: è automatico. Al tuo primo ordine trovi lo sconto del 10% già applicato nella pagina di pagamento, senza dover inserire nessun codice.",
  },
];

const FaqItem = ({ faq, index }) => {
  const [open, setOpen] = useState(false);
  return (
    <Reveal delay={index * 0.05}>
      <div className="bg-mist rounded-2xl overflow-hidden">
        <button
          data-testid={`faq-question-${index}`}
          onClick={() => setOpen(!open)}
          className="w-full flex items-center justify-between gap-4 text-left p-6"
        >
          <span className="font-serif text-lg text-plum">{faq.q}</span>
          <motion.span animate={{ rotate: open ? 45 : 0 }} transition={{ duration: 0.3 }} className="shrink-0">
            <Plus className="w-5 h-5 text-lilac-dark" />
          </motion.span>
        </button>
        <AnimatePresence initial={false}>
          {open && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            >
              <p className="px-6 pb-6 text-sm sm:text-base text-plum/60 leading-relaxed" data-testid={`faq-answer-${index}`}>
                {faq.a}
              </p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </Reveal>
  );
};

export default function FaqPage() {
  return (
    <main data-testid="faq-page" className="py-14 sm:py-20">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center">
          <Reveal>
            <Eyebrow className="justify-center">Domande frequenti</Eyebrow>
            <h1 className="mt-4 font-serif text-4xl sm:text-5xl text-plum tracking-tight">FAQ</h1>
            <p className="mt-4 text-base sm:text-lg text-plum/60">
              Tutto quello che vuoi sapere sui nostri prodotti e sul tuo percorso di cura.
            </p>
          </Reveal>
        </div>
        <div className="mt-12 space-y-3">
          {FAQS.map((faq, i) => (
            <FaqItem key={faq.q} faq={faq} index={i} />
          ))}
        </div>
      </div>
    </main>
  );
}
